import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/wx/wxaccount/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/wx/wxaccount/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/wx/wxaccount/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/wx/wxaccount/submit',
    method: 'post',
    data: row
  })
}

